import React from 'react';
import AIHero from './components/AIHero';
import AIServices from './components/AIServices';
import AIProcess from './components/AIProcess';
import AITechStack from './components/AITechStack';
import WhyChooseUs from '../SoftwareDevelopment/components/WhyChooseUs';
import ContactFormWidget from '../../../components/ContactFormWidget';
import Footer from '../../../components/Footer';

const AIAutomation = () => {
  return (
    <div className="ai-automation-page">
      <AIHero />
      <AIServices />
      <AIProcess />
      <AITechStack />
      <WhyChooseUs />
      <ContactFormWidget />
      <Footer />
    </div>
  );
};

export default AIAutomation; 